import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useForm } from '@inertiajs/react';
import InputError from '@/Components/InputError';

export default function ForgotPasswordModal({ isOpen, closeModal, openLogin }) {
    const { data, setData, post, processing, errors } = useForm({
        email: '',
    });

    const submit = (e) => {
        e.preventDefault();

        post(route('password.email'));
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={closeModal || (() => {})}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-3xl bg-background-dark text-left align-middle shadow-2xl transition-all border border-white/10 relative p-8 md:p-12">

                                {/* Close Button */}
                                <button onClick={closeModal} className="absolute top-4 right-4 z-20 p-2 text-white/50 hover:text-white transition-colors">
                                    <span className="material-symbols-outlined">close</span>
                                </button>

                                <div className="text-center mb-10">
                                    <h1 className="text-3xl font-display font-medium text-white mb-3">Reset Password</h1>
                                    <p className="text-white/50 text-sm font-light">Enter your email address and we'll send you a link to reset your password.</p>
                                </div>

                                <form onSubmit={submit} className="space-y-6">
                                    <div className="space-y-1.5">
                                        <label className="block text-xs font-bold text-primary uppercase tracking-wider" htmlFor="email">Email Address</label>
                                        <div className="relative">
                                            <input
                                                className="block w-full h-12 rounded-xl border border-input-border bg-input-bg text-white shadow-sm focus:border-primary focus:ring-1 focus:ring-primary sm:text-sm pl-12 transition-all outline-none placeholder:text-white/30"
                                                id="email"
                                                type="email"
                                                name="email"
                                                value={data.email}
                                                onChange={(e) => setData('email', e.target.value)}
                                                placeholder="name@example.com"
                                                required
                                                autoFocus
                                            />
                                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-white/50">
                                                <span className="material-symbols-outlined text-[20px]">mail</span>
                                            </div>
                                        </div>
                                        <InputError message={errors.email} className="mt-2" />
                                    </div>

                                    <button
                                        className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-xl shadow-xl text-sm font-bold text-black bg-primary hover:bg-primary/90 focus:outline-none transition-all duration-300 mt-4 uppercase tracking-widest disabled:opacity-50"
                                        type="submit"
                                        disabled={processing}
                                    >
                                        Send Reset Link
                                    </button>
                                </form>

                                <div className="mt-8 text-center">
                                    <button onClick={openLogin} className="text-sm font-medium text-white/50 hover:text-white transition-colors inline-flex items-center">
                                        <span className="material-symbols-outlined text-[16px] mr-1">arrow_back</span>
                                        Back to Login
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
}
